<template>
  <div id="my">
    <div class="hide">
      <InfoHeader/>
    </div>
    <div class="person-header">
      <div class="info">
        <img :src="userInfo.headImgUrl" class="avatar" @click="changeRouter('/baseInfoChange')"/>
        <div class="desc">
          <p class="nick">{{ userInfo.nickName }}</p>
          <p class="number" v-show="userInfo.memberType == 1">
            卡券：{{ userInfo.cardNumber }}张
          </p>
          <p class="number" v-show="userInfo.memberType == 0">
            趣豆：{{ userInfo.currentScore }}个
          </p>
          <!-- <p class="number">趣豆：64546</p> -->
        </div>
      </div>
      <div class="btn">
        <mt-button size="large" type="primary" @click="changeRouter('exchange')"
          >激活兑换码</mt-button
        >
      </div>
      <img src="@/static/images/my/mon.png" class="mon" />
    </div>
    <div class="line"></div>
    <!-- 我的服务 -->
    <div class="my-list">
      <div class="title">我的服务</div>
      <ul>
        <li @click="changeRouter('points')">
          <img src="@/static/images/my/jifen.png" />
          <p>我的趣豆</p>
        </li>
        <li @click="changeRouterByName('OrderList', 1)">
          <img src="@/static/images/my/dingdan.png" />
          <p>我的订单</p>
        </li>
        <li @click="changeRouterByName('OrderList', 2)">
          <img src="@/static/images/my/zhuanrang.png" />
          <p>我的转让</p>
        </li>
        <li @click="changeRouter('Gifts')">
          <img src="@/static/images/my/libao.png" />
          <p>我的礼包</p>
        </li>
      </ul>
      <ul>
        <li @click="changeRouter('Ticket')">
          <img src="@/static/images/my/kaquan.png" />
          <p>我的卡券</p>
        </li>
      </ul>
    </div>
    <div class="line"></div>
    <!-- 其他 -->
    <div class="my-list">
      <div class="title">我的服务</div>
      <ul>
        <li @click="changeRouter('Questions')">
          <img src="@/static/images/my/wendang.png" />
          <p>说明文档</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import InfoHeader from "@/components/InfoHeader.vue";
export default {
  components: {
    InfoHeader,
  },
  methods: {
    changeRouterByName(name, id) {
      this.$router.push({ name, params: { id } });
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
};
</script>

<style lang="less" scoped>
#my {
  .hide{
    display: block; 
    width: 0;
    height: 0;
    overflow: hidden;
  }
  .person-header {
    margin: 26px auto 50px;
    width: 681px;
    height: 311px;
    background-image: linear-gradient(259deg, #27ecb2 0%, #22ba6e 100%);
    // background-image: url("~@/static/images/my/wode_bg.png");
    background-size: cover;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    .info {
      padding-top: 36px;
      margin-left: 52px;
      margin-bottom: 40px;
      display: flex;
      align-items: center;
      .avatar {
        width: 140px;
        height: 141px;
        border-radius: 100%;
      }
      .desc {
        margin-left: 37px;
        color: #fff;
        .nick {
          font-family: PingFang-SC-Bold;
          font-size: 32px;
          font-weight: bold;
          padding-bottom: 13px;
        }
        .number {
          padding-top: 13px;
          font-size: 26px;
        }
      }
      .bg {
        position: absolute;
        width: 681px;
        height: 311px;
        left: 0;
        top: 0;
      }
    }
    .btn {
      margin: 0 auto;
      width: 600px;
      .mint-button--primary {
        height: 64px;
        background-image: linear-gradient(
            90deg,
            #ffb06b 0%,
            #ffa36a 46%,
            #ff9668 100%
          ),
          linear-gradient(#4161f0, #4161f0);
        background-blend-mode: normal, normal;
        border-radius: 64px;
      }
    }
    .mon {
      width: 175px;
      height: 185px;
      // background-color: #3deaaf;
      opacity: 0.55;
      position: absolute;
      top: 30px;
      right: 28px;
    }
  }
  .line {
    height: 13px;
    background-color: #f5f5f5;
  }
  .my-list {
    padding-bottom: 40px;
    .title {
      font-family: PingFang-SC-Heavy;
      font-size: 30px;
      line-height: 36px;
      color: #283349;
      font-weight: bold;
      padding-top: 28px;
      padding-left: 31px;
    }
    ul {
      display: flex;
      padding-left: 54px;
      padding-top: 20px;
      li {
        flex: 0 0 120px;
        padding-right: 40px;
        // background-color: pink;
        img {
          width: 120px;
          height: 120px;
        }
        p {
          text-align: center;
          font-family: PingFang-SC-Medium;
          font-size: 26px;
          color: #283349;
        }
      }
    }
  }
}
</style>
